import React from 'react';

import { Work } from '../components/work/work';

export default () => <Work />;
